import { RefreshCw } from 'lucide-react';
import { useEffect, useSyncExternalStore, type ReactElement } from 'react';

import { Button } from '../design/components.js';

import {
  abonner,
  bandeauVisible,
  demarrerMiseAJour,
  plusTard,
  recharger,
} from './enregistrement.js';
import { saisieEnCours } from './saisie.js';
import './miseajour.css';

/**
 * Bandeau « Nouvelle version disponible » (révision du référent du 2026-10-31), monté une
 * seule fois à côté de l'application (main.tsx). Il n'apparaît que lorsqu'une page ouverte ne
 * peut pas être rechargée sans gêne (saisie en cours, lecture) ; la navigation suivante charge
 * de toute façon la nouvelle version.
 */
export function BandeauMiseAJour(): ReactElement | null {
  useEffect(() => {
    demarrerMiseAJour();
  }, []);
  const visible = useSyncExternalStore(abonner, bandeauVisible, () => false);
  if (!visible) return null;
  return (
    <div className="o-maj" role="status" aria-live="polite">
      <RefreshCw aria-hidden="true" size={18} className="o-maj__icone" />
      <p className="o-maj__texte">
        <strong>Nouvelle version d'Oasis disponible.</strong>{' '}
        {saisieEnCours()
          ? 'Enregistrez votre saisie, puis rechargez la page.'
          : 'Elle s’ouvrira à votre prochain clic, ou tout de suite :'}
      </p>
      <div className="o-maj__actions">
        <Button variant="primary" small onClick={recharger}>
          Recharger
        </Button>
        <Button variant="ghost" small onClick={plusTard}>
          Plus tard
        </Button>
      </div>
    </div>
  );
}
